// A plain <select> styled to match the shadcn Input.
//
// Not part of the shadcn registry — Retool shipped it, and the app leans on it
// wherever the Radix Select would be awkward: on the packing-station tablets a
// native dropdown gets the OS picker, which is far easier to hit than a custom
// popover, and it keeps working inside dialogs and while scrolling.
//
// Children are plain <option> elements, so call sites read as ordinary HTML.

import * as React from 'react'
import { cn } from './utils'

export type NativeSelectProps = React.ComponentProps<'select'>

export function NativeSelect({ className, ...props }: NativeSelectProps) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'flex h-10 w-full appearance-none rounded-md border border-input bg-background px-3 py-2 text-sm',
        'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        // Room for the chevron drawn by the background image below.
        'bg-no-repeat pr-8',
        className,
      )}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")",
        backgroundPosition: 'right 0.5rem center',
        backgroundSize: '1rem',
        ...props.style,
      }}
      {...props}
    />
  )
}
